import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import "../../Dashboard.less"
import { withRouter } from "../../../../lib/withRouter"
import { formatDate, getViewPatientData, postResource } from "../../../../lib"
import moment from "moment"
import RangePicker from "../../../ClaimReview/RangePicker"
import { ArrowDownUp } from "lucide-react"

export class ManageReferral extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func,
        selectedReferral: PropTypes.object,
        referralStatusDropdown: PropTypes.array,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func,
    };

    constructor(props) {
        super(props);
        const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
        const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

        this.state = {
            selectedReferral: null,
            loading: false,
            error: null,
            formData: {
                closureDate: moment().format("YYYY-MM-DD"),
                referralStatus: '',
                referralClosureReason: '',
                providerName: '',
                providerNPI: '',
                providerPhone: ''
            },
            statusSteps: []
        };
    }

    componentDidMount() {
        console.log("Selected Referral for Detail View", this.props.selectedReferral);
        this.loadOldReferralHistory();
    }

    loadOldReferralHistory = async () => {
        const history = await this.fetchOldReferralData(
            this.props.selectedReferral.memberId
        );

        let statusSteps = history
            .filter(item => item?.referralId == this.props.selectedReferral.referralId)
            .map(item => item?.historyStatus);

        // ✅ remove duplicates (optional but usually needed)
        statusSteps = [...new Set(statusSteps)];

        this.setState({
            statusSteps: statusSteps
        });
    };

    fetchOldReferralData = async (memberId) => {
        try {

            let apiUrl = `${this.props.settings.server.baseUrl}/referral/${memberId}/history`;

            const data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server
            });

            console.log("Old Referral Data", data)
            return data?.history ?? [];
        } catch (error) {
            console.error("Dashboard fetch failed:", error);
        }
    };

    handleUpdateStatusSubmit = async () => {
        const { formData } = this.state;
        const { selectedReferral } = this.props;
        try {
            this.setState({ loading: true, error: null });
            let apiUrl = `${this.props.settings.server.baseUrl}/referral/update-status`;
            let payload = {
                referralId: selectedReferral.referralId,
                referralStatusId: formData?.referralStatus,
                updatedDate: formData?.closureDate,
            };
            if (formData?.referralStatus === '1') {
                payload.closureReason = formData?.referralClosureReason;
            }
            console.log("Update Payload", payload);
            const response = await postResource({
                url: apiUrl,
                server: this.props.settings.server,
                data: payload
            });
            console.log("Update Response", response);
            this.setState({ loading: false });
            this.props.onSuccess();
        } catch (error) {
            console.error("Update failed:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    renderUpdateView() {
        const { formData, statusSteps } = this.state;
        const { selectedReferral, onClose, referralStatusDropdown } = this.props;
        if (!selectedReferral) return null;
        return (
            <>
                <div className="patient-sidebar-overlay" onClick={onClose}>
                    <div className="patient-sidebar clr-sidebar" onClick={e => e.stopPropagation()}>

                        {/* Header */}
                        <div className="sidebar-header">
                            <h4>Referral Details - #{selectedReferral.referralId}</h4>
                            <button className="close-btn" onClick={onClose}>
                                <i className="fa fa-times" />
                            </button>
                        </div>

                        {/* Sidebar Content */}
                        <div style={{ padding: "15px", overflowY: "auto", maxHeight: "calc(100vh - 120px)" }}>

                            {/* ================= Member Overview - Compact ================= */}
                            <div className="panel panel-primary" style={{ marginBottom: '10px' }}>
                                <div className="panel-heading" style={{ padding: '8px 15px' }}>
                                    <h5 className="panel-title" style={{ margin: 0, fontSize: '14px' }}>
                                        <i className="fa fa-info-circle"></i> Member Overview
                                    </h5>
                                </div>
                                <div className="panel-body" style={{ padding: '10px 15px' }}>
                                    <div className="row">

                                        <div className="col-xs-3">
                                            <small className="text-muted">Member Name</small>
                                            <div style={{ fontSize: '13px', marginBottom: '8px' }}><strong>{selectedReferral.clientName}</strong></div>
                                        </div>
                                        <div className="col-xs-3">
                                            <small className="text-muted">Service Type</small>
                                            <div style={{ fontSize: '13px', marginBottom: '8px' }}>{selectedReferral.serviceType}</div>
                                        </div>
                                        <div className="col-xs-3">
                                            <small className="text-muted">Referral Type</small>
                                            <div style={{ fontSize: '13px', marginBottom: '8px' }}>{selectedReferral.referralType}</div>
                                        </div>
                                        <div className="col-xs-3">
                                            <small className="text-muted">Status</small>
                                            <div><span className="label label-info">{selectedReferral.currentStatus}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Referral Status Section */}
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    <h5 className="panel-title">Referral Status Update</h5>
                                </div>
                                <div className="panel-body">
                                    <div className="row" style={{ marginBottom: '15px' }}>
                                        <div className="col-sm-4">
                                            <label><strong>Referral Status <span className="text-danger">*</span></strong></label>
                                            <select
                                                className="form-control"
                                                value={formData.referralStatus || ''}
                                                onChange={(e) => this.setState(prev => ({
                                                    formData: {
                                                        ...prev.formData,
                                                        referralStatus: e.target.value
                                                    }
                                                }))}
                                            >
                                                <option value="">-- Select Status --</option>
                                                {referralStatusDropdown?.map((item, index) => {
                                                    if (statusSteps.includes(item.name)) return
                                                    return (
                                                        <option value={item?.id} key={`referralStatus${index}`}>{item?.name}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                        {(formData.referralStatus === '1' || formData.referralStatus === '5') && (
                                            <div className="col-sm-4">
                                                <label><strong>Reason for Referral Loop Closure <span className="text-danger">*</span></strong></label>
                                                <select className="form-control"
                                                    value={formData.referralClosureReason || ''}
                                                    onChange={(e) => this.setState(prev => ({
                                                        formData: {
                                                            ...prev.formData,
                                                            referralClosureReason: e.target.value
                                                        }
                                                    }))}>
                                                    <option value="">-- Select Reason --</option>
                                                    <option value="Services Received">Services Received</option>
                                                    <option value="Service Provider Declined">Service Provider Declined</option>
                                                    <option value="Unable to Reach Member">Unable to Reach Member</option>
                                                    <option value="Member No Longer Eligible for Services">Member No Longer Eligible for Services</option>
                                                    <option value="Member No Longer Needs Services or Declines Services">Member No Longer Needs Services or Declines Services</option>
                                                    <option value="Authorization Denied">Authorization Denied</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>
                                        )}
                                        <div className="col-sm-4">
                                            <label><strong>Date <span className="text-danger">*</span></strong></label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={formData.closureDate || ''}
                                                onChange={(e) => this.setState(prev => ({
                                                    formData: {
                                                        ...prev.formData,
                                                        closureDate: e.target.value
                                                    }
                                                }))}
                                            />
                                        </div>
                                    </div>
                                    <div style={{
                                        // padding: "5px 10px",
                                        // borderTop: "1px solid #ddd",
                                        // backgroundColor: "#f9f9f9",
                                        // position: "absolute",
                                        // bottom: 0,
                                        // width: "100%"
                                    }}>
                                        <button type="button" className="btn btn-sm btn-default" onClick={onClose}>
                                            <i className="fa fa-times"></i> Close
                                        </button>
                                        <button type="button" className="btn btn-sm btn-primary" style={{ marginLeft: "10px" }} onClick={this.handleUpdateStatusSubmit}>
                                            <i className="fa fa-save"></i> Save Changes
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Servicing Provider Details */}
                            {/* <div className="panel panel-default">
                                <div className="panel-heading">
                                    <h5 className="panel-title">Servicing Provider Details</h5>
                                </div>
                                <div className="panel-body">
                                    <div className="row" style={{ marginBottom: '15px' }}>
                                        <div className="col-sm-12">
                                            <label><strong>Servicing Provider Name</strong></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter provider name"
                                                value={formData.providerName || ''}
                                                onChange={(e) => this.setState(prev => ({
                                                    formData: {
                                                        ...prev.formData,
                                                        providerName: e.target.value
                                                    }
                                                }))}
                                            />
                                        </div>
                                    </div>

                                    <div className="row" style={{ marginBottom: '15px' }}>
                                        <div className="col-sm-6">
                                            <label><strong>Provider NPI</strong></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter NPI"
                                                value={formData.providerNPI || ''}
                                                onChange={(e) => this.setState(prev => ({
                                                    formData: {
                                                        ...prev.formData,
                                                        providerNPI: e.target.value
                                                    }
                                                }))}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <label><strong>Provider Phone</strong></label>
                                            <input
                                                type="tel"
                                                className="form-control"
                                                placeholder="Enter phone number"
                                                value={formData.providerPhone || ''}
                                                onChange={(e) => this.setState(prev => ({
                                                    formData: {
                                                        ...prev.formData,
                                                        providerPhone: e.target.value
                                                    }
                                                }))}
                                            />
                                        </div>
                                    </div>

                                    <div style={{
                                        // padding: "5px 10px",
                                        // borderTop: "1px solid #ddd",
                                        // backgroundColor: "#f9f9f9",
                                        // position: "absolute",
                                        // bottom: 0,
                                        // width: "100%"
                                    }}>
                                        <button type="button" className="btn btn-sm btn-default" onClick={this.handleCloseDetail}>
                                            <i className="fa fa-times"></i> Close
                                        </button>
                                        <button type="button" className="btn btn-sm btn-primary" style={{ marginLeft: "10px" }}>
                                            <i className="fa fa-save"></i> Save Changes
                                        </button>
                                    </div>
                                </div>
                            </div> */}

                            {/* Service Outcome Section */}
                            {/* <div className="panel panel-default">
                                <div className="panel-heading">
                                    <h5 className="panel-title">Service Outcome</h5>
                                </div>
                                <div className="panel-body">
                                    <div className="row" style={{ marginBottom: '15px' }}>
                                        <div className="col-sm-12">
                                            <label><strong>Service Delivered?</strong></label>
                                            <div>
                                                <label className="radio-inline">
                                                    <input type="radio" name="delivered" value="yes" /> Yes
                                                </label>
                                                <label className="radio-inline">
                                                    <input type="radio" name="delivered" value="no" /> No
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row" style={{ marginBottom: '15px' }}>
                                        <div className="col-sm-12">
                                            <label><strong>Service Date</strong></label>
                                            <input type="date" className="form-control" />
                                        </div>
                                    </div>

                                    <div className="row" style={{ marginBottom: '15px' }}>
                                        <div className="col-sm-12">
                                            <label><strong>Outcome Category</strong></label>
                                            <select className="form-control">
                                                <option value="">-- Select Category --</option>
                                                <option value="confirmed">Confirmed</option>
                                                <option value="denied">Denied</option>
                                                <option value="other">Other</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row" style={{ marginBottom: '15px' }}>
                                        <div className="col-sm-12">
                                            <label><strong>Outcome Notes</strong></label>
                                            <textarea className="form-control" rows="3" placeholder="Enter outcome notes"></textarea>
                                        </div>
                                    </div>

                                    <div className="row" style={{ marginBottom: '15px' }}>
                                        <div className="col-sm-12">
                                            <label><strong>Follow-up Required?</strong></label>
                                            <div>
                                                <label className="radio-inline">
                                                    <input type="radio" name="followup" value="yes" /> Yes
                                                </label>
                                                <label className="radio-inline">
                                                    <input type="radio" name="followup" value="no" /> No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            {/* Outreach Confirmation */}
                            {/* <div className="panel panel-default">
                                <div className="panel-heading">
                                    <h5 className="panel-title">Outreach & Confirmation</h5>
                                </div>
                                <div className="panel-body">
                                    <div className="row" style={{ marginBottom: '15px' }}>
                                        <div className="col-sm-12">
                                            <label><strong>Outreach Occurred?</strong></label>
                                            <div>
                                                <label className="radio-inline">
                                                    <input type="radio" name="outreach" value="yes" /> Yes
                                                </label>
                                                <label className="radio-inline">
                                                    <input type="radio" name="outreach" value="no" /> No
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row" style={{ marginBottom: '15px' }}>
                                        <div className="col-sm-12">
                                            <label><strong>Outreach Date</strong></label>
                                            <input type="date" className="form-control" />
                                        </div>
                                    </div>

                                    <div className="row" style={{ marginBottom: '15px' }}>
                                        <div className="col-sm-12">
                                            <label><strong>Outreach Method</strong></label>
                                            <select className="form-control">
                                                <option value="">-- Select Method --</option>
                                                <option value="phone">Phone Call</option>
                                                <option value="email">Email</option>
                                                <option value="mail">Mail</option>
                                                <option value="in_person">In Person</option>
                                                <option value="other">Other</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row" style={{ marginBottom: '15px' }}>
                                        <div className="col-sm-12">
                                            <label><strong>Services Were Rendered?</strong></label>
                                            <div>
                                                <label className="radio-inline">
                                                    <input type="radio" name="servicesRendered" value="yes" /> Yes
                                                </label>
                                                <label className="radio-inline">
                                                    <input type="radio" name="servicesRendered" value="no" /> No
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row" style={{ marginBottom: '15px' }}>
                                        <div className="col-sm-12">
                                            <label><strong>Additional Notes</strong></label>
                                            <textarea className="form-control" rows="4" placeholder="Enter any additional supporting details"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                        </div>

                        {/* Footer Buttons */}
                        {/* <div style={{
                            padding: "5px 10px",
                            borderTop: "1px solid #ddd",
                            backgroundColor: "#f9f9f9",
                            position: "absolute",
                            bottom: 0,
                            width: "100%"
                        }}>
                            <button type="button" className="btn btn-sm btn-default" onClick={this.handleCloseDetail}>
                                <i className="fa fa-times"></i> Close
                            </button>
                            <button type="button" className="btn btn-sm btn-primary" style={{ marginLeft: "10px" }}>
                                <i className="fa fa-save"></i> Save Changes
                            </button>
                        </div> */}
                    </div>
                </div>
            </>
        );
    }

    render() {
        return (
            <>
                {this.renderUpdateView()}
            </>
        );
    }
}

export default connect(state => state)(withRouter(ManageReferral));
